var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1662.57 504.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e186a;}.cls-2,.cls-6{fill:#fff;}.cls-11,.cls-2,.cls-3{stroke:#2e186a;}.cls-11,.cls-2,.cls-3,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-8,.cls-9{stroke-width:6px;}.cls-11,.cls-3,.cls-8,.cls-9{fill:none;}.cls-4{fill:#fe7624;}.cls-5{fill:#feba91;}.cls-7{fill:#5d21d1;}.cls-8{stroke:#fff;}.cls-9{stroke:#fffdfd;}.cls-10{fill:#968bb4;}.cls-11{stroke-width:8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team_at_work",
    "data-name": "team at work"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cap_man",
    "data-name": "cap man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shirt",
    className: "cls-1",
    d: "M530.15,498.46c-3.13-36.55-28.61-89.06-34.31-139.39,38.4-35.93-3.11-140.57-26-141.7-23.08-4.24-43.08-8.48-80-9.77-45.59-1.59-86.83,3.89-102.1,6.09-57.07,28.25-88.12,194-50.51,226.69,7.12,6.19,18.59,12.39,32.64,18.17-1.2,14-2,28-2,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck",
    className: "cls-2",
    d: "M347.37,213.29l8.25-49.64,62,23.27L420,222.2C411.62,283.8,345.55,224.21,347.37,213.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hair_back",
    "data-name": "hair back",
    className: "cls-1",
    d: "M433.55,70.31S386,100.11,409,128.25c0,0,10.25,11.76,18.74,9.46,0,0-6.2-10,1-15.12,0,0,2.15,29.89,26.64,23.85,0,0-9-13.25-6.53-29.1C453.9,84.26,446.3,64.38,433.55,70.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face",
    className: "cls-2",
    d: "M335.06,117.42S326,59.07,385,49c5.5-.94,43.22-6.59,50.09,24.69,4.59,20.9,5.46,43.58,4.9,61.2,0,.1-.57,33.27-13.68,51.7s-42.16,16.71-57.52,7.63-18.17-13.81-22.47-24.58-11.21-52.12-11.21-52.12Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "nose",
    className: "cls-3",
    points: "415.71 121.98 421.17 148.88 411.1 148.88"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II",
    "data-name": "eye II",
    className: "cls-1",
    cx: 428.07,
    cy: 119.71,
    rx: 4.6,
    ry: 2.97,
    transform: "translate(304.18 546.58) rotate(-89.44)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye",
    className: "cls-1",
    cx: 399.66,
    cy: 119.97,
    rx: 4.6,
    ry: 2.97,
    transform: "translate(203.47 488.26) rotate(-78.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II",
    "data-name": "brow II",
    className: "cls-3",
    d: "M384.07,102.13a13.6,13.6,0,0,1,12.74-5.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow",
    className: "cls-3",
    d: "M422.77,94.43S433,89.84,437.5,96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_front",
    "data-name": "hair front",
    className: "cls-1",
    d: "M381.36,73.93s22.3,78.18-29.7,86.22c0,0-30.29,5.35-37.21-5.35,0,0,21.95-11.66,19.19-24.19,0,0-24.68,27.06-46.16,7.64,0,0,35.85-6,32.67-38.24C317.87,76.88,373.37,55.17,381.36,73.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cap",
    className: "cls-4",
    d: "M286.32,84.94,318,80.15c3.28-21.33,15.7-51.87,59.42-56.94,68.31-7.94,70.35,58.54,70.35,58.54l-158.34,23.6a10.32,10.32,0,1,1-3.09-20.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    className: "cls-3",
    d: "M394.2,155.73s4.32,10.12,18.59,7.87"
  })), /*#__PURE__*/React.createElement("path", {
    id: "puzzle",
    className: "cls-5",
    d: "M548.89,278.34V244.06a25.27,25.27,0,0,0-25.27-25.27h-9.86a62.87,62.87,0,1,1-125.73,0h-9.86a25.28,25.28,0,0,0-25.27,25.27v182.7A25.27,25.27,0,0,0,378.17,452H523.62a25.27,25.27,0,0,0,25.27-25.27V404.07a62.87,62.87,0,0,0,0-125.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "handII"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M531.62,443.46c-.14-.43-22.08-26-22.82-25.46S478,432,477.34,433.05s-1.81,7.09,1.22,12.73,6.36,18.5,19.95,19.51S531.62,443.46,531.62,443.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M491.5,423.9S488.94,406.23,493,402s27,35,34.89,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.32,427s-5.46-12.9,1.77-19.14,25.06,29.06,32.89,33.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.08,441.81s-9.24-23.11-2.8-28,16.88,25.08,29.4,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M526.26,438.84h0A25,25,0,0,0,524.79,424c-2.27-5.35-5-12.63-5.24-17.28-.45-8.1,12.8-4.3,13.35.73s3.07,4.74,8.87,9.86,4.74,25.54,4.74,25.54,5.1,10.47-11.34,23-34,2.78-34,2.78S469.4,456.89,469.41,434s8.43,10.48,24.33,19.87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.37,443.46c.15-.43,22.08-26,22.82-25.46s30.8,14,31.46,15.05,1.82,7.09-1.22,12.73-6.36,18.5-19.95,19.51S354.37,443.46,354.37,443.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.5,423.9S397.05,406.23,393,402s-27,35-34.89,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.67,427s5.47-12.9-1.77-19.14S379.84,436.91,372,441.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M409.91,441.81s9.24-23.11,2.81-28-16.89,25.08-29.4,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.73,438.84h0A25.08,25.08,0,0,1,361.2,424c2.27-5.35,5-12.63,5.24-17.28.45-8.1-12.79-4.3-13.35.73s-3.07,4.74-8.87,9.86-4.74,25.54-4.74,25.54-5.1,10.47,11.34,23,34,2.78,34,2.78S416.6,456.89,416.59,434s-8.44,10.48-24.34,19.87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "woman"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    className: "cls-1",
    d: "M884.87,213.53,818.05,203l-7.18-22.7c12.47-7.94,54.52-4.16,87.26,7.93l-13.26,25.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape-2",
    "data-name": "shape",
    className: "cls-7",
    d: "M994.45,339.88,944.73,223.67c-3.19-7.2-9.89-12.53-18-14.68a39.68,39.68,0,0,0-13.28-3.53l-16.86-1.41,1.51-15.87s-2.35,5.71-20.9,9.19c-25.08,4.71-66.36-17.12-66.36-17.12v24.6l-25.57-.73c-11-.32-32.35-1.19-44.71,23.29L680.45,378.33c-10.65,19.49-5.14,48.34,12.56,63.2L728.11,461l-3.26,39,265.63-.91L989,464.48C1069.69,414.37,994.45,339.88,994.45,339.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M777.1,383.43s-26.36-32.6-66.6-3.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M777.1,377.7c-.43-.87-16-36.17-59.75-13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M932.27,383.43s24-42.76,69.86-13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M929.28,375.32s12.82-33.13,55.3-25.38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "head-2",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "neck-2",
    "data-name": "neck",
    className: "cls-2",
    points: "819.93 202.09 819.93 134.93 878.89 170.46 877.51 206.54 819.93 202.09"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head-3",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face-2",
    "data-name": "face",
    className: "cls-2",
    d: "M898,62.93c-24-16.62-45.64-22.71-79.5,20.69l-4.63,28.57c-14.23-4.29-21.73,2.65-18.63,15.06,3.33,13.37,11.08,19.38,24,15.9h0c6.17,14,17.85,30.11,39.56,34.81,34,7.37,41.85-13.67,45.64-21.94S922,79.56,898,62.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "face-3",
    "data-name": "face"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "nose-2",
    "data-name": "nose",
    className: "cls-3",
    points: "886.68 115.27 889.62 140.85 880.06 140.61"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II-2",
    "data-name": "eye II",
    className: "cls-1",
    cx: 897.79,
    cy: 115.2,
    rx: 2.85,
    ry: 4.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-2",
    "data-name": "eye",
    className: "cls-1",
    cx: 870.32,
    cy: 114.72,
    rx: 2.85,
    ry: 4.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow-2",
    "data-name": "brow",
    className: "cls-3",
    d: "M895.7,89.51s7.92-2.06,9.9,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth-2",
    "data-name": "mouth",
    className: "cls-1",
    d: "M867.91,146.09s9.17,3.33,16.93,2c0,0-2.91,13.27-10.39,11.66S867.91,146.09,867.91,146.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M772.79,32.25C757.54,2.4,733-.21,704.68,5.42s-44.13,43.7-45.12,47.23c-11.55,41.17,3.74,85.18,37.7,111.16,3.77,2.87,7.54,5.79,11.15,8.61,20,15.63-24.25,29-24.25,29,84.69,6.79,66.22-78,64.42-85.48C775.68,105.59,787,60,772.79,32.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 767.93,
    y: 37.21,
    width: 26.87,
    height: 79.52,
    rx: 13.44,
    transform: "translate(425.86 777.02) rotate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-2",
    "data-name": "hair",
    className: "cls-1",
    d: "M921.79,92.12c-.3-20.78-5.29-39-17.84-51a24,24,0,0,0-7.06-5.57c-10.24-6.63-24.14-10.18-42.58-9.52a3,3,0,0,0-1.13.3,76.72,76.72,0,0,0-8.6,1.28,31.84,31.84,0,0,0-4.6,1.08,90.12,90.12,0,0,0-14.81,5.44C783.81,51.92,767.53,84,786,128.31c9.54,22.84,21.92,30.19,33.89,30.21V144.69c-1-2.2-2.71-1.35-2.71-1.35-12.88,3.48-18.64-2.72-22-16.09-1.62-6.46-.35-11.43,3.23-14.11l.28-.21c.14-.1.29-.19.44-.28l.29-.18.49-.26.29-.13a5.38,5.38,0,0,1,.55-.24l.27-.1c.2-.07.41-.15.62-.21l.19,0a14.6,14.6,0,0,1,3.58-.55h.09q.45,0,.93,0h.18c.31,0,.63,0,.94,0h.21l1,.1.15,0a31.5,31.5,0,0,1,4.91,1.08h0c1.1.33.29.85,1.48,1.32l3-.21c1,0,2.08-.1,3.18-.23,26.11-3.14,66.67-21.82,81.12-45.82,10.2,12.36,11.31,36.73,9.44,57.26A58,58,0,0,0,921.79,92.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "brow-3",
    "data-name": "brow",
    className: "cls-9",
    d: "M859.21,89.4a13.07,13.07,0,0,1,12.38-4.87"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "puzzle-2",
    "data-name": "puzzle",
    className: "cls-5",
    d: "M939.43,274l-6.29-33.38a25,25,0,0,0-29.24-20l-9.6,1.81a62.29,62.29,0,1,0-122.42,23.08l-9.6,1.81a25,25,0,0,0-20,29.24l6.29,33.38a62.29,62.29,0,0,1,23.08,122.42l4.17,22.09a25,25,0,0,0,29.24,20l141.62-26.7a25,25,0,0,0,20-29.24l-4.16-22.1A62.28,62.28,0,1,1,939.43,274Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "handII-2",
    "data-name": "handII"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M805.28,451.06c13.51,9.59,15.27,2.32,11.31-2.33-5-5.81-28.49-24.34-28.49-24.34s18.87,5.62,23.49-5-.43-12.71-7.54-9.1-29.2-9.41-29.2-9.41l-7.24-6.65s-24.3-7.82-30.55,19.06a27.12,27.12,0,0,0,5.26,25.95c2.89,3.27,12.9,16.3,44.63,32.15,0,0,14.88,5.53,3.74-5.22a86.68,86.68,0,0,0-8.79-7.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.16,436.62c4.73,3.51,24.49,14.61,29.21,21.69s-1.19,9.44-18.08-2.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.85,444.22c.52.86,32.93,18.4,30.83,23-1.73,3.76-6.35,4-24.27-7.4l-14.39-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-2",
    "data-name": "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M923.59,421.06c-15.75,5.12-15.26-2.34-10.1-5.6C920,411.39,948,400.74,948,400.74s-19.69-.28-20.92-11.83,4.21-12,9.92-6.44,30.68-.25,30.68-.25l8.9-4.19s25.52-.22,23.46,27.3a27.14,27.14,0,0,1-12.77,23.21c-3.73,2.26-17.17,11.7-52.19,17.35,0,0-15.86.84-2-6.1a86.4,86.4,0,0,1,10.6-4.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M948.06,413.58c-5.56,1.94-27.74,6.63-34.35,12s-1.68,9.36,18.08,2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M952.77,423c-.76.66-36.92,7.73-36.29,12.74.52,4.1,4.88,5.66,25.37.18l16.74-5.29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "developer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "body-2",
    "data-name": "body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hoodie",
    className: "cls-4",
    d: "M1476.83,289c.26-54.62-79.4-73.4-79.4-73.4,6-27.14,3.25-94.16-110.28-73.66-58.15,10.06-74.6,40.59-62.24,65.34-22.62,11.22-79.08,92.15-79.08,92.15l1.06,69.56a65.52,65.52,0,0,0-13.09-1.38,64.74,64.74,0,0,0-65,64.45c-.15,35.75,31.74,67.73,67.49,67.88a58.39,58.39,0,0,0,12.59-1.31l0,1.32,308.67-.8s1.46-61.86-5.91-127.52C1464.56,342,1476.74,308.86,1476.83,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-shirt",
    className: "cls-6",
    d: "M1347.4,182.32,1368,193.73s-53.59,23.14-63.27,130c-6.29,69.43-1.29,177.72-1.29,177.72l-35.42-.55s9.55-214.71-5.89-249.65,1.59-37.14,9.39-44.4S1347.4,182.32,1347.4,182.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "welt_II",
    "data-name": "welt II",
    className: "cls-1",
    cx: 1122.26,
    cy: 426.26,
    r: 51.37
  }), /*#__PURE__*/React.createElement("circle", {
    id: "welt",
    className: "cls-1",
    cx: 1309.68,
    cy: 430.57,
    r: 44.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "shadow_II",
    "data-name": "shadow II",
    className: "cls-1",
    d: "M1346.37,278.8c8.9-4.05,37.22-36.44,51-63.41,11.5-.17,28.12,7.7,35.33,13.29C1400,280.37,1346.32,278.88,1346.37,278.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines-2",
    "data-name": "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1340.14,371.63s39.49-16.5,68.86,29.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1337.3,372.18s31.13-31.58,73.58,8.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1450.24,374.88s-38.11,136-138.08,107.37c0,0-17.76-4.43-26.24-16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1326.1,389A192.58,192.58,0,0,0,1346,356.91c9.84-19.63,22.55-51.17,22.55-51.17"
  })), /*#__PURE__*/React.createElement("path", {
    id: "neck-3",
    "data-name": "neck",
    className: "cls-2",
    d: "M1349,139l-1.53,47.39a20.56,20.56,0,0,1-7.44,16.36c-9.18,7.64-26,22.71-47.13,46.56,0,0-26.36-28.07-30.81-71.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head-4",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ear",
    className: "cls-2",
    d: "M1355.43,114.62s21,.5,17.12,19.23-26.93,7.79-26.93,7.79l3.21-26.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face-4",
    "data-name": "face",
    className: "cls-2",
    d: "M1296,55.26c-5.52-.48-43.34-3-47.61,28.52s0,66.4,3.47,82.33,75.88,8.87,80,7.47,9-6.19,9-6.19L1351,119S1355.3,60.44,1296,55.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beard",
    className: "cls-10",
    d: "M1344,118.53c-3.55,3.46-13.14,23.47-15.5,32.81,0,0-23.48-8-57.16-8.58,0,0-18.37.29-25.7,2.41,0,0,1.44,33.11,16.26,50.31s46.32,12.54,61.14,2.3,17.27-15.15,20.74-26.16,12.67-52.07,12.67-52.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-3",
    "data-name": "hair",
    className: "cls-1",
    d: "M1353.56,125.65s9.9-15.19,13.77-31c3.63-14.87-3.22-30.5-17-37.22-11.5-5.64-20.07-1.3-20.07-1.3s12.32-20.78-6-39.26A33.43,33.43,0,0,0,1299.8,7a32.21,32.21,0,0,0-29.43,19.49s-23.82-44.21-73.14-18.32c-5,2.61-10.6,9.93-13.3,14.86-16.38,29.88,37,65.59,64.91,68.51,30.61,3.22,48.55-1.78,58.45-9.23C1299.93,86.65,1308,132.5,1353.56,125.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth-3",
    "data-name": "mouth",
    className: "cls-11",
    d: "M1293.84,165.77s-4.76,10.56-15.68,6.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "nose-3",
    "data-name": "nose",
    className: "cls-11",
    points: "1271.48 130.02 1265.34 154.93 1278.23 156.28"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II-3",
    "data-name": "eye II",
    className: "cls-1",
    cx: 1259.05,
    cy: 126.23,
    rx: 4.57,
    ry: 2.95,
    transform: "translate(1127.4 1384.72) rotate(-89.75)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-3",
    "data-name": "eye",
    className: "cls-1",
    cx: 1287.5,
    cy: 125.85,
    rx: 4.57,
    ry: 2.95,
    transform: "translate(1156.1 1412.79) rotate(-89.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II-2",
    "data-name": "brow II",
    className: "cls-11",
    d: "M1302.19,109a13.54,13.54,0,0,0-12.8-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow-4",
    "data-name": "brow",
    className: "cls-11",
    d: "M1262.26,103.31s-8.18-2.17-10.26,4.52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "puzzle-3",
    "data-name": "puzzle",
    className: "cls-5",
    d: "M1285.27,204.36l-146.12-.63a25.39,25.39,0,0,0-25.5,25.28l-.15,34.44a63.16,63.16,0,0,0-.54,126.31l-.1,22.79A25.38,25.38,0,0,0,1138.14,438l146.12.63a25.38,25.38,0,0,0,25.49-25.27l.79-183.54A25.38,25.38,0,0,0,1285.27,204.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand-3",
    "data-name": "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1102.6,425.32c.14-.44,22.08-26.06,22.82-25.46s30.79,14,31.45,15.05,1.82,7.08-1.21,12.72-6.36,18.51-20,19.52S1102.6,425.32,1102.6,425.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1142.72,405.75s2.56-17.66-1.52-21.85-27,35-34.89,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1154.89,408.85s5.47-12.91-1.76-19.15-25.06,29.06-32.89,33.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1158.14,423.67s9.24-23.11,2.8-28-16.88,25.09-29.4,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1108,420.7h0a25,25,0,0,1,1.47-14.84c2.27-5.36,5-12.63,5.24-17.29.45-8.1-12.8-4.29-13.35.73s-3.07,4.75-8.88,9.86-4.73,25.54-4.73,25.54-5.1,10.47,11.34,23,34,2.78,34,2.78,31.81-11.73,31.8-34.62-8.43,10.48-24.33,19.88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "handII-3",
    "data-name": "handII"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1307.8,428.25c-.14-.44-22.07-26.06-22.82-25.46s-30.79,14-31.45,15-1.82,7.08,1.21,12.72,6.37,18.51,20,19.52S1307.8,428.25,1307.8,428.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1267.68,408.68s-2.56-17.66,1.52-21.85,27,35,34.89,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1255.51,411.78s-5.47-12.91,1.77-19.15,25,29.06,32.89,33.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1252.26,426.6s-9.24-23.11-2.8-28,16.89,25.08,29.4,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1302.44,423.63h0a25,25,0,0,0-1.47-14.84c-2.26-5.36-5-12.63-5.24-17.28-.45-8.11,12.8-4.3,13.36.72s3.06,4.75,8.87,9.87,4.73,25.54,4.73,25.54,5.1,10.47-11.34,23-34,2.79-34,2.79-31.81-11.74-31.8-34.63,8.43,10.48,24.33,19.88"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "line",
    className: "cls-2",
    x1: 3,
    y1: 501.46,
    x2: 1659.57,
    y2: 501.46
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab);
export default __webpack_public_path__ + "static/media/collab.8faafabd3398a8d68c277dc1e20bd575.svg";
export { ForwardRef as ReactComponent };